import { ProductTagBase } from '../ProductTagBase';
import klass from '../style/ProductTag.module.scss';
import { differenceInHours, intervalToDuration } from 'date-fns';

export class PeriodLimitedTag extends ProductTagBase<Date> {
  /**
   * @figma
   * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=21842-60385&m=dev
   */
  protected makeLabel(): string | undefined {
    const currentTime = new Date();
    const endDate = this.data.value;
    const hoursLeft = differenceInHours(endDate, currentTime);

    // 1. 168시간 이상
    if (hoursLeft >= 168) {
      return undefined;
    } else if (hoursLeft >= 24) {
      // 2. 24시간 이상 AND 168시간 미만
      const daysLeft = Math.floor(hoursLeft / 24);

      // `N일 남았어요!`
      return ET('mps2::product::tag::period_limited_day', {
        day: daysLeft,
        lng: this.data.lang,
      });
    } else if (currentTime < endDate) {
      // 3. 24시간 미만

      // duration을 HH:MM:SS 형식으로 포맷팅
      const duration = intervalToDuration({ start: currentTime, end: endDate });
      const hours = String(duration.hours || 0).padStart(2, '0');
      const minutes = String(duration.minutes || 0).padStart(2, '0');
      const seconds = String(duration.seconds || 0).padStart(2, '0');

      // `HH:MM:SS 남았어요!`
      return ET('mps2::product::tag::period_limited', {
        time: `${hours}:${minutes}:${seconds}`,
        lng: this.data.lang,
      });
    }
  }

  protected styles(): string {
    return klass.limited;
  }

  isTimerNeeded(): boolean {
    return true;
  }
}
